// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"1e3147d4","167":"314e785a","321":"0fae00e7","412":"80542cad","649":"9dea29c0","987":"a8e69b58"}[chunkId] + ".chunk.css";
};